import { createResourceStore } from './createResourceStore';

const useUserTemplateStore = createResourceStore({
  endpoint: '/admin/user_templates',
  collectionKey: 'userTemplates',
  itemKey: 'user_template',
  listResponseKey: 'user_templates',
  paginated: true,
  totalKey: 'totalUserTemplates',
  hasFetchById: true,
  extraState: { userTemplate: null },
  itemStateKey: 'userTemplate',
  mapListParams: (page = 1, search = '', userId = '', orgId = '') => ({
    page,
    search,
    userId,
    orgId,
  }),
  methods: {
    fetch: 'fetchUserTemplates',
    create: 'createUserTemplate',
    update: 'updateUserTemplate',
    delete: 'deleteUserTemplate',
    fetchById: 'fetchUserTemplateById',
  },
});

export default useUserTemplateStore;
